import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';

/**
 * PreviewBanner - Shows preview mode indicator
 */
export const PreviewBanner = () => {
  const { t } = useTranslation('transparency');
  return (
    <Alert
      severity="info"
      icon={<VisibilityIcon />}
      sx={{ mb: 2, borderRadius: 2 }}
    >
      <AlertTitle sx={{ fontWeight: 600 }}>{t('preview.banner.title')}</AlertTitle>
      {t('preview.banner.body')}
    </Alert>
  );
};
